import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  return (
    <>
      <Navbar />
      <main className="pt-16 min-h-screen flex items-center justify-center bg-background-50">
        <div className="text-center px-4">
          <div className="text-8xl font-heading font-bold text-primary-500 mb-4">404</div>
          <h1 className="text-2xl font-heading font-bold text-foreground-950 mb-3">页面未找到</h1>
          <p className="text-sm text-foreground-600 mb-8 max-w-md mx-auto">
            您访问的页面不存在或已被移除。请检查网址是否正确，或返回首页继续浏览。
          </p>
          <Link
            to="/"
            className="inline-flex px-6 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            返回首页
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}